import { useI18n } from "@/i18n/I18nProvider";
import { SEO } from "@/components/SEO";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { InternalLinks } from "@/components/InternalLinks";

export function TermsPage() {
  const { t, lang, prefix } = useI18n();
  const isSv = lang === "sv";
  const title = isSv ? "Användarvillkor" : "Terms of use";
  const desc = isSv
    ? "Användarvillkor för CasinoMenu.se."
    : "Terms of use for CasinoMenu.se.";
  return (
    <div className="container-page py-8">
      <SEO title={title} description={desc} />
      <Breadcrumbs items={[{ label: t("nav.home"), href: prefix }, { label: title }]} />
      <h1 className="mt-3 text-3xl font-extrabold md:text-4xl">{title}</h1>

      <article className="prose prose-ink mt-6 max-w-3xl [&>h2]:mt-10 [&>h2]:mb-3 [&>h2]:text-2xl [&>h2]:font-bold [&>p]:my-3 [&>ul]:my-3 [&>ul]:list-disc [&>ul]:pl-6">
        <h2>{isSv ? "Innehållets karaktär" : "Nature of the content"}</h2>
        <p>
          {isSv
            ? "Innehållet på CasinoMenu.se är endast i informationssyfte. Vi är inte ett spelbolag, en bank eller en juridisk rådgivare. Vi tillhandahåller inte juridisk rådgivning, skatterådgivning eller investeringsrådgivning. Kontrollera alltid lokala regler innan du spelar och kontakta en oberoende rådgivare när det gäller skatter."
            : "The content on CasinoMenu.se is for informational purposes only. We are not a gambling operator, a bank or a legal advisor. We do not provide legal advice, tax advice or investment advice. Always verify local rules before playing and consult an independent advisor on tax matters."}
        </p>

        <h2>{isSv ? "Affiliate-länkar" : "Affiliate links"}</h2>
        <p>
          {isSv
            ? "CasinoMenu.se kan få ersättning när du klickar på vissa länkar och spelar hos en operatör. Det påverkar inte våra omdömen eller vårt redaktionella innehåll. Affiliate-länkar är märkta som ”sponsored” och ”nofollow” i HTML-koden."
            : "CasinoMenu.se may receive compensation when you click certain links and play at an operator. This does not affect our reviews or editorial content. Affiliate links are flagged as ”sponsored” and ”nofollow” in the HTML."}
        </p>

        <h2>{isSv ? "Åldersgräns och ansvarsfullt spelande" : "Age limit and responsible gambling"}</h2>
        <p>
          {isSv
            ? "Casinospel är 18+ i Sverige. Spel kan vara beroendeframkallande. Spela aldrig för pengar du inte har råd att förlora. Behöver du hjälp ringer du Stödlinjen 020-81 91 00 — det är gratis och anonymt."
            : "Casino gambling is 18+ in Sweden. Gambling can be addictive. Never gamble money you cannot afford to lose. If you need help call Stödlinjen at 020-81 91 00 — it is free and anonymous."}
        </p>

        <h2>{isSv ? "Korrekthet och uppdatering" : "Accuracy and updates"}</h2>
        <p>
          {isSv
            ? "Vi gör vårt bästa för att hålla informationen korrekt och aktuell. Bonusvillkor, RTP-värden, betalningsmetoder och licensstatus kan dock ändras snabbt. Innan du registrerar konto eller accepterar en bonus — kontrollera alltid de aktuella villkoren direkt hos operatören."
            : "We do our best to keep information accurate and current. Bonus terms, RTP values, payment methods and license status can change quickly. Before opening an account or accepting a bonus, always verify the current terms directly with the operator."}
        </p>

        <h2>{isSv ? "Användning av sajten" : "Use of the site"}</h2>
        <ul>
          <li>{isSv ? "Du får läsa, dela länkar till och citera kort från CasinoMenu.se i normalt redaktionellt syfte." : "You may read, link to, and briefly quote CasinoMenu.se for ordinary editorial use."}</li>
          <li>{isSv ? "Du får inte kopiera hela sidor eller spegla webbplatsen utan skriftligt tillstånd." : "You may not copy entire pages or mirror the site without written permission."}</li>
          <li>{isSv ? "Du får inte använda automatiserade verktyg som överskrider rimlig användning eller belastar våra servrar onödigt." : "You may not use automated tools that exceed reasonable use or unnecessarily strain our servers."}</li>
          <li>{isSv ? "Du får inte använda CasinoMenu.se på ett sätt som kringgår Spelpaus eller andra svenska konsumentskydd." : "You may not use CasinoMenu.se to circumvent Spelpaus or other Swedish consumer protections."}</li>
        </ul>

        <h2>{isSv ? "Friskrivning" : "Disclaimer"}</h2>
        <p>
          {isSv
            ? "CasinoMenu.se ansvarar inte för spelförluster, missade bonusar eller skattemässiga konsekvenser av tredjepartsoperatörers tjänster. Du spelar alltid på egen risk hos den operatör du väljer."
            : "CasinoMenu.se is not liable for gambling losses, missed bonuses or tax implications arising from third-party operators. You always gamble at your own risk with the operator you choose."}
        </p>
      </article>

      <InternalLinks context="static" />
    </div>
  );
}
